module.exports = __webpack_public_path__ + "static/media/Оазис глубокой сна - Быстрый сон с фортепиано.4b7330c4.mp3";